
import Request from '@scripts/request.js';

import SBM from '@scripts/utilities/sbm.js';


var RestClient = function(nonce) {
  this.nonce = nonce;
};
RestClient.prototype.get = function(url) {
  var request = new window.Request(
    url,
    { headers: { 'X-WP-Nonce': this.nonce } }
  );

  return window.fetch(request).then(this.formatResponse);
};
RestClient.prototype.post = function(url, data) {
  var postData = JSON.stringify(data);
  var nonce = this.nonce;

  return new Promise(function(resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-WP-Nonce', nonce);
    xhr.onreadystatechange = function() {
      if (this.readyState != 4) {
        return;
      }

      if (this.status == 200) {
        if (this.responseText) {
          resolve(JSON.parse(this.responseText));
        } else {
          resolve(null);
        }
      } else {
        if (this.responseText) {
          reject(JSON.parse(this.responseText));
        } else {
          reject({ message: 'API call has failed (status ' + this.status + ')' });
        }
      }
    };

    xhr.send(postData);
  });
};
RestClient.prototype.formatResponse = function(response) {
  return response.json();
};


var client = new RestClient(SBM.restNonce);


export default client;

